import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const LotsDayChart = ({ data }) => {
  const [Series, setSeries] = useState([
    {
      name: "Trades per day",
      type: "line",
      data: [],
    },
    {
      name: " Lots  per day",
      type: "line",
      data: [],
    },
  ]);
  const [Option, setOption] = useState({
    responsive: [
      {
        breakpoint: 425,
        options: {
          chart: {
            height: 350,
            width: 300,
          },
        },
      },
      {
        breakpoint: 325,
        options: {
          chart: {
            height: 300,
            width: 250,
          },
        },
      },
    ],
    fill: {
      opacity: 1,
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },
    colors: ["#37C976", "#  FD504F"],
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      borderColor: "#415672",
      strokeDashArray: 8,
    },
    labels:
      (data &&
        data.date &&
        Object.keys(data.date).map((info) => data.date[info])) ||
      [],
    xaxis: {
      type: "datetime",
      // categories: [],
      // tooltip: {
      //   enabled: false,
      // },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        rotate: -45,
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        seriesName: "Trades per day",
        title: {
          text: "Trades per day",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        labels: {
          formatter: (value) => {
            return Number(value).toFixed(2);
          },
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
      {
        opposite: true,
        seriesName: "Lots  per day",
        title: {
          text: "Lots  per day",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        labels: {
          formatter: (value) => {
            return Number(value).toFixed(2);
          },
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },

      // type: 'datetime',
    ],
  });

  useEffect(() => {
    const TradesArr =
      data &&
      data.trade &&
      Object.keys(data.trade).map((info) => data.trade[info]);
    const LotsArr =
      data &&
      data.lots &&
      Object.keys(data.lots).map((info) => data.lots[info]);

    setSeries([
      {
        name: "Trades per day",
        type: "line",
        data: TradesArr,
      },
      {
        name: "Lots per day",
        type: "line",
        data: LotsArr,
      },
    ]);

    setOption({
      ...Option,
      labels:
        (data &&
          data.date &&
          Object.keys(data.date).map((info) => data.date[info])) ||
        [],
    });
  }, [data]);

  return (
    <div id="chart">
      <ReactApexChart options={Option} series={Series} height={250} />
    </div>
  );
};
export default LotsDayChart;
